import axios from 'axios';

const ImpoundAnalysisService = {
  async createImpoundAnalysis({
    loanId,
    startingInvoiceId,
    initialImpoundBalance,
    previousInsuranceAmount,
    previousTaxAmount,
    previousHoaAmount,
    taxPayment,
    insurancePayment,
    hoaPayment,
    totalCushion,
    adjustment,
    calculatedData,
  }) {
    const response = await axios.post('/impound_analysis', {
      loan_id: loanId,
      starting_invoice_id: startingInvoiceId,
      initial_impound_balance: initialImpoundBalance,
      previous_insurance_amount: previousInsuranceAmount,
      previous_tax_amount: previousTaxAmount,
      previous_hoa_amount: previousHoaAmount,
      new_tax_amount: taxPayment,
      new_insurance_amount: insurancePayment,
      new_hoa_amount: hoaPayment,
      cushion_total: totalCushion,
      adjustment: adjustment.toFixed(2),
      calculation_table: calculatedData,
    });

    return response.data;
  },

  async getImpoundAnalysis(analysisId) {
    const response = await axios.get(`/impound_analysis/${analysisId}`);

    return response.data;
  },

  async deleteImpoundAnalysis(analysisId) {
    const response = await axios.delete(`/impound_analysis/${analysisId}`);

    return response.data;
  },
};

export default ImpoundAnalysisService;
